import { render, staticRenderFns } from "./CategoryModel.vue?vue&type=template&id=5108d870&scoped=true"
import script from "./CategoryModel.vue?vue&type=script&lang=js"
export * from "./CategoryModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5108d870",
  null
  
)

export default component.exports